import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { MENU_SLUG } from "../../constants/constants";
import LoginLeftBg from "../../components/loginLeftBg";
import useMediaQuery from "../../hooks/useMediaQuery";
import axios from "../../api/axios";
import LogoImg from "../../assets/images/logo.png";
import Step1 from "./step1";
import Step2 from "./step2";
import Step3 from "./step3";
import Step4 from "./step4";
import styles from "./style.module.css";

const ForgotPassword = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(1);
  const [step1FormData, setStep1FormData] = useState({});
  const [step2FormData, setStep2FormData] = useState("");
  const [step3FormData, setStep3FormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const onStep1FormSubmit = useCallback(async (data) => {
    setStep1FormData(data);
    try {
      setErrorMessage("");
      setLoading(true);
      let url = `auth/forgot-password`;
      let options = {
        method: "POST",
        url,
        data,
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      };
      await axios(options)
        .then((response) => {
          if (response.data.status === 1) {
            setActiveStep(2);
          }
          setLoading(false);
        })
        .catch((err) => {
          if (err.response) {
            setLoading(false);
            setErrorMessage(err.response.data.message);
          }
        });
    } catch (error) {
      setLoading(false);
    }
  }, []);

  const onStep2FormSubmit = (data) => {
    setStep2FormData(data);
    let tempData = {
      email: step1FormData.email,
      forgotPasswordCode: data,
    };
    handleVerifyEmail(tempData);
  };

  const handleVerifyEmail = useCallback(async (data) => {
    try {
      setErrorMessage("");
      setLoading(true);
      let url = `auth/verify-forgot-password`;
      let options = {
        method: "POST",
        url,
        data,
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      };
      await axios(options)
        .then((response) => {
          if (response.data.status === 1) {
            setActiveStep(3);
          }
          setLoading(false);
        })
        .catch((err) => {
          if (err.response) {
            setLoading(false);
            setErrorMessage(err.response.data.message);
          }
        });
    } catch (error) {
      setLoading(false);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onStep3FormSubmit = (data) => {
    setStep3FormData(data);
    let tempData = { ...data };
    const email = step1FormData.email;
    tempData.email = email;
    tempData.forgotPasswordCode = step2FormData;
    handleSetPassword(tempData);
  };

  const handleSetPassword = useCallback(async (data) => {
    try {
      setLoading(true);
      setErrorMessage("");
      let url = `auth/set-new-password`;
      let options = {
        method: "POST",
        url,
        data,
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      };
      await axios(options)
        .then((response) => {
          if (response.data.status === 1) {
            setStep1FormData({});
            setStep2FormData("");
            setStep3FormData({});
            setActiveStep(4);
          }
          setLoading(false);
        })
        .catch((err) => {
          if (err.response) {
            setLoading(false);
            setErrorMessage(err.response.data.message);
          }
        });
    } catch (error) {
      setLoading(false);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onResend = () => {
    let tempData = {
      email: step1FormData.email,
    };
    handleResendCode(tempData);
  };
  const handleResendCode = useCallback(async (data) => {
    try {
      setErrorMessage("");
      setLoading(true);
      let url = `auth/resend-passcode`;
      let options = {
        method: "POST",
        url,
        data,
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      };
      await axios(options)
        .then((response) => {
          if (response.data.status === 1) {
          }
          setLoading(false);
        })
        .catch((err) => {
          if (err.response) {
            setLoading(false);
            setErrorMessage(err.response.data.message);
          }
        });
    } catch (error) {
      setLoading(false);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onBackClick = () => {
    if (activeStep > 1) {
      setActiveStep(activeStep - 1);
    } else {
      navigate(`/${MENU_SLUG.login}`);
    }
  };

  useEffect(() => {
    setActiveStep(1);
  }, []);

  return (
    <div className={styles.main}>
      {isMobile && (
        <div className={styles.main_logo}>
          <img src={LogoImg} alt="Logo" />
        </div>
      )}
      <div className={styles.main_container}>
        {!isMobile && (
          <div className={styles.main_left}>
            <LoginLeftBg />
          </div>
        )}
        <div className={styles.main_right}>
          <div className={styles.form_container}>
            {activeStep === 1 && (
              <Step1
                formData={step1FormData}
                onFormSubmit={onStep1FormSubmit}
                onBackClick={onBackClick}
                loading={loading}
                errorMessage={errorMessage}
              />
            )}
            {activeStep === 2 && (
              <Step2
                onFormSubmit={onStep2FormSubmit}
                onBackClick={onBackClick}
                onResendClick={onResend}
                loading={loading}
                errorMessage={errorMessage}
              />
            )}
            {activeStep === 3 && (
              <Step3
                formData={step3FormData}
                onFormSubmit={onStep3FormSubmit}
                onBackClick={onBackClick}
                loading={loading}
                errorMessage={errorMessage}
              />
            )}
            {activeStep === 4 && <Step4 />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
